import { WinnerStatusEnum } from 'shared/constants/shared-enums';

export function didICaptureTheWin(status: WinnerStatusEnum, amIPlayerA: boolean): boolean {
  return (
    (!amIPlayerA &&
      [WinnerStatusEnum.WinnerPlayerB, WinnerStatusEnum.TechnicalWinnerB].includes(status)) ||
    (amIPlayerA &&
      [WinnerStatusEnum.WinnerPlayerA, WinnerStatusEnum.TechnicalWinnerA].includes(status)) ||
    status === WinnerStatusEnum.PlayerAExitRoom
  );
}

export const TECHNICAL_FINISH_STATUSES = [
  WinnerStatusEnum.TechnicalWinnerA,
  WinnerStatusEnum.TechnicalWinnerB,
  WinnerStatusEnum.UnusedRoomClosed,
  WinnerStatusEnum.PlayerAExitRoom,
];
